import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EventsRoutingModule } from './events-routing.module';
import { EventPageComponent } from './pages/event-page/event-page.component';
import { EventsService } from './services/events.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { EventsPageComponent } from './pages/events-page/events-page.component';
import { TimelineSlotComponent } from './components/timeline-slot/timeline-slot.component';
import { EventPageResolver } from './resolvers/events-page.resolver';
import { GoogleMapsModule } from "@angular/google-maps";

@NgModule({
  declarations: [
    EventPageComponent,
    EventsPageComponent,
    TimelineSlotComponent
  ],
  imports: [
    CommonModule,
    EventsRoutingModule,
    SharedModule,
    GoogleMapsModule,
  ],
  providers: [
    EventsService,
    EventPageResolver,
  ]
})
export class EventsModule { }
